(($) => {

    function switchOrientation(orientation) {
        $('[data-portrait]').each(function (index, item) {

            let video = $(item).parent('video')[0];
            video.pause();
            item.src = $(item).data(orientation);

            video.load();
            $(video).trigger('orientationchange', [item]);
            //video.play()

        });
    }

    $(window).ready(function () {

        let mql = window.matchMedia("(orientation: portrait)");

        // If there are matches, we're in portrait
        if (mql.matches) {
            switchOrientation('portrait') //'data-landscape'
        } else {
            // Landscape orientation
            switchOrientation('landscape')
        }
    })


})(jQuery);
